export default __webpack_public_path__ + "static/media/gallery-wip-pre-paint_04.bc931d6d.jpg";